{
  "common": { "lastUpdated": "آخر تحديث: {{date}}" },
  "privacy": {
    "title": "إشعار الخصوصية",
    "updated": "7 أغسطس 2026",
    "intro": "يوضح هذا الإشعار كيف تقوم <strong>{{tradingName}}</strong> (&ldquo;نحن&rdquo;) بجمع البيانات الشخصية واستخدامها. نحن نعمل بصفتنا <strong>جهة التحكم في البيانات</strong> للبيانات الشخصية الموضحة أدناه، أي أننا من يقرر سبب وكيفية معالجتها.",
    "dataCollected": {
      "heading": "البيانات التي نجمعها والغرض منها",
      "items": [
        "<strong>بيانات حساب ولي الأمر</strong> (الاسم، البريد الإلكتروني، رقم الهاتف، الدولة، المنطقة الزمنية) &mdash; لإنشاء حسابك وإدارته وتقديم الدروس والتواصل معك. الأساس القانوني: تنفيذ عقدنا معك.",
        "<strong>بيانات ملف الطفل</strong> (الاسم الأول، العمر أو الصف الدراسي، مستوى التعلم والأهداف) &mdash; لوضع طفلك في المجموعة المناسبة وتخصيص التدريس. الأساس القانوني: تنفيذ العقد، بموافقتك كولي أمر.",
        "<strong>محتوى التعلّم</strong> (تسجيلات صوتية للواجبات، أوراق العمل، ملاحظات المعلم، تقارير التقدّم) &mdash; للتدريس والتقييم وإعداد تقارير عن التقدّم. الأساس القانوني: تنفيذ العقد.",
        "<strong>رسائل الدعم واستفسارات التقييم</strong> &mdash; للإجابة عن الأسئلة وتنظيم الدروس. الأساس القانوني: تنفيذ العقد ومصلحتنا المشروعة في الرد على الاستفسارات.",
        "<strong>بيانات الاستخدام والجهاز والسجلّات</strong> (عنوان IP، معرّفات الجهاز والمتصفح، الصفحات التي تمت زيارتها، أحداث تسجيل الدخول) &mdash; للأمان ومنع الاحتيال وحل المشكلات وتحسين الخدمة. الأساس القانوني: المصلحة المشروعة.",
        "<strong>تفضيلات التسويق</strong> &mdash; لإرسال التحديثات التي طلبتها. الأساس القانوني: الموافقة، ويمكنك سحبها في أي وقت."
      ],
      "noChildData": "نحن لا نجمع بيانات مباشرة من الأطفال عن قصد؛ يتم إنشاء الحسابات وإدارتها من قبل أحد الوالدين أو ولي الأمر."
    },
    "shareWith": {
      "heading": "مع من نشارك البيانات",
      "items": [
        "<strong>مزوّدو الخدمات / المعالجون الفرعيون</strong> &mdash; مزوّدو الاستضافة وقواعد البيانات ودروس الفيديو وإرسال البريد الإلكتروني والتحليلات الذين يعملون وفق تعليماتنا.",
        "<strong>Stripe</strong>، معالج المدفوعات لدينا، لإتمام عمليات الشراء وإدارة الاشتراكات والمدفوعات وحساب الضرائب والفوترة.",
        "<strong>المستشارون المهنيون</strong> &mdash; القانونيون والمحاسبون عند الضرورة.",
        "<strong>السلطات</strong> &mdash; عند مطالبة القانون بذلك أو لحماية حقوقنا."
      ],
      "noSell": "نحن لا نبيع البيانات الشخصية."
    },
    "transfers": {
      "heading": "عمليات النقل الدولية",
      "body": "قد يقوم مزوّدونا بمعالجة البيانات خارج بلدك، بما في ذلك خارج المملكة المتحدة/المنطقة الاقتصادية الأوروبية. وفي هذه الحالة، نعتمد على ضمانات مناسبة مثل قرارات الملاءمة أو البنود التعاقدية القياسية."
    },
    "retention": {
      "heading": "الاحتفاظ بالبيانات",
      "body": "نحتفظ ببيانات الحساب والتعلّم طوال فترة نشاط حسابك ولمدة تصل إلى 24 شهرًا بعد ذلك، حتى تظل تقارير التقدّم متاحة إذا عدت. أما السجلات التي يتوجب علينا الاحتفاظ بها لأسباب قانونية أو ضريبية أو محاسبية، فتُحفظ للمدة التي يقتضيها القانون. بعد ذلك، تُحذف البيانات أو يتم إخفاء هويتها."
    },
    "rights": {
      "heading": "حقوقك",
      "body": "وفقًا للقانون المعمول به، يمكنك طلب الوصول إلى بياناتك أو تصحيحها أو حذفها أو تقييد معالجتها أو نقلها، والاعتراض على المعالجة القائمة على المصلحة المشروعة. يمكنك سحب موافقتك في أي وقت. أرسل لنا رسالة عبر <0>تواصل معنا</0> وسنرد خلال شهر واحد. إذا كنت مقيمًا في المملكة المتحدة أو المنطقة الاقتصادية الأوروبية، يحق لك أيضًا تقديم شكوى إلى سلطة الرقابة المحلية لديك."
    },
    "security": {
      "heading": "الأمان",
      "body": "نستخدم تدابير تقنية وتنظيمية مناسبة، تشمل التشفير أثناء النقل، وضوابط الوصول، وأمان قاعدة البيانات على مستوى الصف، وتخزينًا خاصًا لملفات الواجبات المرفوعة، بحيث لا يتمكن من الوصول إلى الأعمال المُقدَّمة سواك أنت والمعلّم المخصّص لطفلك."
    },
    "cookies": {
      "heading": "ملفات تعريف الارتباط",
      "body": "نستخدم ملفات تعريف الارتباط الأساسية والتخزين المحلي للحفاظ على تسجيل دخولك وتأمين الخدمة. وقد نستخدم ملفات تعريف ارتباط تحليلية محدودة لفهم كيفية استخدام الموقع. يمكنك إدارة ملفات تعريف الارتباط أو حظرها من إعدادات متصفحك؛ ومع ذلك فإن حظر الملفات الأساسية سيمنع عمل تسجيل الدخول."
    },
    "contact": {
      "heading": "التواصل",
      "body": "أسئلة الخصوصية: <0>تواصل معنا</0>."
    }
  },
  "terms": {
    "title": "الشروط والأحكام",
    "updated": "7 أغسطس 2026",
    "intro": "تحكم هذه الشروط والأحكام استخدامك لموقع {{tradingName}} وخدماتنا التعليمية للغة الإنجليزية عبر الإنترنت مباشرة للأطفال الذين تتراوح أعمارهم بين 4 و12 عامًا (&ldquo;الخدمة&rdquo;). تُقدَّم الخدمة من قِبل <strong>{{legalName}}</strong>{{tradingSuffix}} (&ldquo;نحن&rdquo;). بإنشائك حسابًا أو حجز تقييم أو شراء خطة، فإنك تدخل في اتفاق معنا.",
    "tradingSuffix": "، التي تعمل تحت اسم {{tradingName}}",
    "sections": {
      "acceptance": {
        "heading": "1. القبول",
        "body": "من خلال الوصول إلى الخدمة أو مواصلة استخدامها فإنك توافق على هذه الشروط. إذا كنت تقوم بالشراء نيابة عن مؤسسة، فإنك تؤكد أن لديك السلطة لإلزامها. وإذا كنت تشتري كفرد، فإنك تؤكد أنك بلغت السن القانونية وأنك الوالد أو ولي الأمر القانوني للطفل المسجَّل."
      },
      "service": {
        "heading": "2. الخدمة",
        "body": "نقدّم دروس لغة إنجليزية مباشرة ومجدولة عبر الإنترنت، تُقدَّم في مجموعات صغيرة أو بشكل فردي، إلى جانب مواد تعليمية ومراجعة للواجبات وتقارير عن التقدّم. قد تتغير أوقات الدروس وتشكيلة المجموعات وطاقم التدريس من وقت لآخر. يجوز لنا تحديث المنهج أو تحسينه دون إشعار مسبق، شريطة الحفاظ على المستوى العام للخدمة."
      },
      "accounts": {
        "heading": "3. الحسابات ودقة المعلومات",
        "items": [
          "يجب عليك تقديم معلومات دقيقة عن الحساب والطفل والحفاظ على تحديثها.",
          "أنت مسؤول عن الحفاظ على سرية بيانات تسجيل الدخول الخاصة بك وعن جميع الأنشطة التي تتم من خلال حسابك، بما في ذلك استخدام طفلك له.",
          "الحسابات مخصصة لعائلة واحدة ولا يجوز مشاركتها أو إعادة بيعها."
        ]
      },
      "acceptableUse": {
        "heading": "4. الاستخدام المقبول",
        "intro": "يجب ألا تسيء استخدام الخدمة. وعلى وجه الخصوص، يجب ألا:",
        "items": [
          "تستخدم الخدمة لأي غرض غير قانوني، أو بما يخالف أي لائحة معمول بها؛",
          "تنخرط في الاحتيال أو الرسائل غير المرغوب فيها أو المضايقة أو الإساءة أو السلوك المخل أثناء الدروس؛",
          "تنتهك ملكيتنا الفكرية أو ملكية طرف ثالث، بما في ذلك عن طريق تسجيل أو نسخ أو إعادة توزيع أو إعادة بيع محتوى الدروس أو موادها؛",
          "تتدخل في أمان أو سلامة الخدمة، بما في ذلك من خلال إدخال برمجيات خبيثة أو فحص الأنظمة أو استخراج بيانات الموقع."
        ]
      },
      "licence": {
        "heading": "5. الترخيص والقيود",
        "body": "نمنحك حقًا محدودًا وغير حصري وغير قابل للتحويل للوصول إلى الخدمة والمواد المضمّنة في الخطة التي اخترتها، للاستخدام الشخصي والعائلي غير التجاري. لا يجوز لك عكس هندسة الخدمة أو إعادة بيعها أو ترخيصها من الباطن أو تجاوز أي قيود تقنية عليها."
      },
      "ip": {
        "heading": "6. الملكية الفكرية",
        "body": "نحتفظ بجميع حقوق ملكية الخدمة وملكيتها الفكرية، بما في ذلك المنهج وأوراق العمل والتسجيلات والبرمجيات والعلامة التجارية والوثائق. تظل الأعمال التي يقدّمها طفلك (مثل تسجيلات الواجبات الصوتية وأوراق العمل) ملكًا لك؛ وأنت تمنحنا ترخيصًا محدودًا لاستضافتها ومعالجتها فقط من أجل تقديم الخدمة وتحسينها لك."
      },
      "serviceLevel": {
        "heading": "7. مستوى الخدمة",
        "body": "نسعى إلى تقديم الدروس بشكل موثوق، لكننا لا نضمن أن تكون الخدمة غير منقطعة أو في الوقت المناسب أو آمنة أو خالية من الأخطاء. وإلى أقصى حد يسمح به القانون، نتنصّل من جميع الضمانات الضمنية، بما في ذلك القابلية للتسويق والملاءمة لغرض معين. تعتمد نتائج التعلّم على عوامل عديدة وهي غير مضمونة."
      },
      "payments": {
        "heading": "8. المدفوعات والفوترة والاشتراكات",
        "body1": "تُفوتَر الخطط شهريًا مقدمًا بالدولار الأمريكي ما لم يُذكر خلاف ذلك عند الدفع، وتتجدد تلقائيًا حتى إلغائها. يمكنك الإلغاء في أي وقت من بوابة أولياء الأمور أو من خلال بوابة الفوترة؛ ويستمر الوصول حتى نهاية الفترة التي دفعت مقابلها.",
        "body2": "تتم معالجة المدفوعات بشكل آمن من خلال مزوّد المدفوعات لدينا، Stripe. نحن البائع المسجَّل لجميع الطلبات ونظل مسؤولين عن الخدمة واستفسارات الفوترة والمبالغ المستردة. تُعالَج بيانات البطاقة من قِبل Stripe ولا تُخزَّن أبدًا في أنظمتنا. تُحسَب الضرائب المعمول بها وتُعرَض عند الدفع. راجع <0>سياسة الاسترداد</0> الخاصة بنا لمعرفة كيفية عمل المبالغ المستردة."
      },
      "suspension": {
        "heading": "9. التعليق والإنهاء",
        "body": "يجوز لنا تعليق الوصول أو إنهاءه في حال وجود خرق جوهري لهذه الشروط، أو عدم السداد، أو مخاطر أمنية أو احتيالية، أو انتهاكات متكررة أو جسيمة للسياسات. وحيثما أمكن، سنبلغك أولًا ونمنحك فرصة لحل المشكلة. عند الإنهاء ينتهي وصولك؛ ويمكنك طلب تصدير الأعمال التي قدّمها طفلك خلال 30 يومًا، وبعد ذلك يمكن حذفها."
      },
      "liability": {
        "heading": "10. المسؤولية",
        "body": "إلى أقصى حد يسمح به القانون، تقتصر مسؤوليتنا الإجمالية الناشئة عن الخدمة أو المتعلقة بها على الرسوم التي دفعتها خلال الأشهر الاثني عشر السابقة للمطالبة. نستبعد المسؤولية عن الأضرار غير المباشرة أو التبعية أو الخاصة، بما في ذلك خسارة الأرباح أو البيانات أو السمعة التجارية. لا يحد شيء في هذه الشروط من المسؤولية عن الاحتيال أو الوفاة أو الإصابة الشخصية الناجمة عن الإهمال، أو أي مسؤولية أخرى لا يجوز استبعادها قانونًا."
      },
      "indemnity": {
        "heading": "11. التعويض",
        "body": "توافق على تعويضنا عن أي مطالبات ناشئة عن المحتوى الذي تقدّمه أنت أو طفلك، أو الاستخدام غير القانوني للخدمة، أو خرق هذه الشروط."
      },
      "changes": {
        "heading": "12. تعديلات على هذه الشروط",
        "body": "يجوز لنا تحديث هذه الشروط؛ وسننشر النسخة المعدَّلة هنا ونحدّث التاريخ أعلاه. يشكّل استمرار الاستخدام بعد سريان التغييرات قبولًا بها."
      },
      "general": {
        "heading": "13. أحكام عامة",
        "body": "لا يجوز لك التنازل عن حقوقك دون موافقتنا؛ ويجوز لنا التنازل عن حقوقنا فيما يتعلق باندماج أو استحواذ. لا يتحمل أي طرف المسؤولية عن التأخيرات الناجمة عن أحداث خارجة عن سيطرته المعقولة. تخضع هذه الشروط لقوانين الولاية القضائية للبائع، وتتمتع محاكم تلك الولاية القضائية بالاختصاص الحصري في النظر في النزاعات."
      },
      "contact": {
        "heading": "14. التواصل",
        "body": "أسئلة حول هذه الشروط أو الفوترة أو الطلبات: <0>تواصل معنا</0>."
      }
    }
  },
  "refund": {
    "title": "سياسة الاسترداد",
    "updated": "7 أغسطس 2026",
    "intro": "نريد أن تشعر كل عائلة بالثقة تجاه تعلّم طفلها. تقدّم <strong>{{legalName}}</strong> <strong>ضمان استرداد الأموال لمدة {{refundDays}} يومًا</strong> على الخطط الشهرية.",
    "window": {
      "heading": "فترة الاسترداد الخاصة بك",
      "body": "إذا لم تكن راضيًا عن عملية الشراء، يمكنك طلب استرداد كامل خلال {{refundDays}} يومًا من تاريخ طلبك. ينطبق هذا على تغيير الرأي وكذلك على المشكلات المتعلقة بالخدمة."
    },
    "howTo": {
      "heading": "كيفية طلب استرداد الأموال",
      "items": [
        "أرسل لنا رسالة عبر <0>تواصل معنا</0>، باستخدام عنوان البريد الإلكتروني الذي استخدمته عند الدفع، وأخبرنا بالخطة وتاريخ الطلب.",
        "يمكنك أيضًا إدارة خطتك أو إلغاؤها في أي وقت من بوابة الفوترة داخل بوابة أولياء الأمور."
      ]
    },
    "cancelling": {
      "heading": "إلغاء خطتك",
      "body": "يمكنك الإلغاء في أي وقت من بوابة أولياء الأمور أو من خلال بوابة الفوترة. يؤدي الإلغاء إلى إيقاف عمليات التجديد المستقبلية؛ ويحتفظ طفلك بإمكانية الوصول إلى الدروس والمواد حتى نهاية الفترة التي دفعت مقابلها بالفعل."
    },
    "renewals": {
      "heading": "التجديدات",
      "body": "إذا كانت رسوم التجديد غير متوقعة، تواصل معنا خلال {{refundDays}} يومًا من تاريخ الرسوم وسنراجعها ونعيدها عند الاقتضاء."
    },
    "processing": {
      "heading": "وقت المعالجة",
      "body": "تُعاد المبالغ المستردة المعتمدة إلى وسيلة الدفع الأصلية. واعتمادًا على البنك أو جهة إصدار البطاقة، عادةً ما تظهر الأموال خلال 5 إلى 10 أيام عمل."
    }
  }
}
